
<template>
  <el-card size="small" class="changer-user-card">
    <el-input
      ref="myInput"
      v-model="channelCode"
      placeholder="请输入渠道编码"
      clearable
      @keydown.enter.native="submitForm"
    />
  </el-card>
</template>

<script>
import { changUser } from '@/API';

export default {
  name: 'ChangeChannel',
  data () {
    return {
      channelCode: '',
      isLoading: false
    };
  },
  methods: {
    submitForm () {
      this.isLoading = true;
      changUser({ userId: this.channelCode, role: '1' })
        .finally(() => (this.isLoading = false))
        .then(res => {
          let { status } = res.data;
          if (status === '200') {
            window.location.href = window.location.origin;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.changer-user-card {
  width: 30vmax;
  margin: 30px auto;
  .ant-form-item {
    margin-bottom: 0 !important;
  }
}
</style>
